<template>
    <step-choice
        tab-class="tab-age"
        headline="Fangen wir an. Wie alt sind Sie?"
        :options="options"
        @answer="$emit('answer', $event)"
    ></step-choice>
</template>

<script>
import StepChoice from './StepChoice'

export default {
    components: { StepChoice },

    data() {
        return {
            options: [
                { label: '18-29', value: '18-29' },
                { label: '30-44', value: '30-44' },
                { label: '45-59', value: '45-59' },
                { label: '60+', value: '60+' }
            ]
        }
    }
}
</script>
